import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSearch, FiPlus, FiUsers, FiZap } = FiIcons;

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="flex justify-center mb-6">
            <div className="bg-white rounded-full p-4 shadow-lg border border-gray-200">
              <SafeIcon icon={FiSearch} className="text-4xl text-[#2b6777]" />
            </div>
          </div>
          <h1 className="text-5xl font-bold text-[#2b6777] mb-4 font-rubik">
            Willkommen beim Buchstabensalat
          </h1>
          <p className="text-xl text-[#2b6777] max-w-2xl mx-auto font-rubik opacity-80">
            Erstelle interaktive Wortsuche-Spiele und teile sie mit Freunden. 
            Kein Login erforderlich - einfach spielen!
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex justify-center mb-16"
        >
          <Link
            to="/create"
            className="bg-[#c8d8e4] hover:bg-[#b5c7d1] text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-200 shadow-lg hover:shadow-xl flex items-center gap-3 font-rubik"
          >
            <SafeIcon icon={FiPlus} className="text-xl" />
            Neues Spiel erstellen
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto"
        >
          <div className="bg-white rounded-lg p-6 shadow-lg text-center border border-gray-200">
            <div className="bg-blue-100 rounded-full p-3 w-12 h-12 mx-auto mb-4 flex items-center justify-center">
              <SafeIcon icon={FiZap} className="text-[#2b6777] text-xl" />
            </div>
            <h3 className="text-lg font-semibold text-[#2b6777] mb-2 font-rubik">
              Sofort spielbereit
            </h3>
            <p className="text-[#2b6777] opacity-80 font-rubik">
              Keine Anmeldung nötig. Erstelle ein Spiel und teile den Link.
            </p>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-lg text-center border border-gray-200">
            <div className="bg-green-100 rounded-full p-3 w-12 h-12 mx-auto mb-4 flex items-center justify-center">
              <SafeIcon icon={FiUsers} className="text-[#2b6777] text-xl" />
            </div>
            <h3 className="text-lg font-semibold text-[#2b6777] mb-2 font-rubik">
              Multiplayer
            </h3>
            <p className="text-[#2b6777] opacity-80 font-rubik">
              Spiele gleichzeitig mit Freunden und seht euren Fortschritt in Echtzeit.
            </p>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-lg text-center border border-gray-200">
            <div className="bg-purple-100 rounded-full p-3 w-12 h-12 mx-auto mb-4 flex items-center justify-center">
              <SafeIcon icon={FiSearch} className="text-[#2b6777] text-xl" />
            </div>
            <h3 className="text-lg font-semibold text-[#2b6777] mb-2 font-rubik">
              Automatische Generierung
            </h3>
            <p className="text-[#2b6777] opacity-80 font-rubik">
              Gib deine Wörter ein und wir erstellen automatisch das perfekte Rätsel.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default HomePage;